/**
 * New Expedient
 * Expedient for Student Account
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import Error from '../model/Error';
import InlineResponse2002 from '../model/InlineResponse2002';
import StudentAcademicRecordTitle from '../model/StudentAcademicRecordTitle';

/**
* StudentAcademicProgramsTitle service.
* @module api/StudentAcademicProgramsTitleApi
* @version 1.0
*/
export default class StudentAcademicProgramsTitleApi {

    /**
    * Constructs a new StudentAcademicProgramsTitleApi. 
    * @alias module:api/StudentAcademicProgramsTitleApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * get student academic programs title from mad by student
     * @param {Number} studentId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/StudentAcademicRecordTitle>} and HTTP response
     */
    studentAcademicProgramTitleDocumentControllerShowByStudentWithHttpInfo(studentId) {
      let postBody = null;
      // verify the required parameter 'studentId' is set
      if (studentId === undefined || studentId === null) {
        throw new Error("Missing the required parameter 'studentId' when calling studentAcademicProgramTitleDocumentControllerShowByStudent");
      }

      let pathParams = {
        'student_id': studentId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['BearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [StudentAcademicRecordTitle];
      return this.apiClient.callApi(
        '/student-academic-programs-title/students/{student_id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * get student academic programs title from mad by student
     * @param {Number} studentId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/StudentAcademicRecordTitle>}
     */
    studentAcademicProgramTitleDocumentControllerShowByStudent(studentId) {
      return this.studentAcademicProgramTitleDocumentControllerShowByStudentWithHttpInfo(studentId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * get tar from id
     * @param {Number} id 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/StudentAcademicRecordTitle>} and HTTP response
     */
    studentAcademicProgramTitleDocumentControllerShowCurrentWithHttpInfo(id) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling studentAcademicProgramTitleDocumentControllerShowCurrent");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['BearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [StudentAcademicRecordTitle];
      return this.apiClient.callApi(
        '/student-academic-programs-title/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * get tar from id
     * @param {Number} id 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/StudentAcademicRecordTitle>}
     */
    studentAcademicProgramTitleDocumentControllerShowCurrent(id) {
      return this.studentAcademicProgramTitleDocumentControllerShowCurrentWithHttpInfo(id)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Upload documentation
     * @param {String} student 
     * @param {Object} opts Optional parameters
     * @param {File} opts.file Archivo a subir
     * @param {Number} opts.academicProgramId 
     * @param {String} opts.payedAt
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/InlineResponse2002} and HTTP response
     */
    studentAcademicProgramTitleDocumentControllerStoreWithHttpInfo(student, opts) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'student' is set
      if (student === undefined || student === null) {
        throw new Error("Missing the required parameter 'student' when calling studentAcademicProgramTitleDocumentControllerStore");
      }

      let pathParams = {
        'student': student
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'file': opts['file'],
        'academic_program_id': opts['academicProgramId'],
        'payed_at': opts['payedAt']
      };

      let authNames = ['BearerAuth'];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['application/json'];
      let returnType = InlineResponse2002;
      return this.apiClient.callApi(
        '/student-academic-programs-title/students/{student}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Upload documentation
     * @param {String} student 
     * @param {Object} opts Optional parameters
     * @param {File} opts.file Archivo a subir
     * @param {Number} opts.academicProgramId 
     * @param {String} opts.payedAt
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/InlineResponse2002}
     */
    studentAcademicProgramTitleDocumentControllerStore(student, opts) {
      return this.studentAcademicProgramTitleDocumentControllerStoreWithHttpInfo(student, opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
